import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BookingPriceService {

    private totalPriceSubject = new BehaviorSubject<number>(0);
    private totalVatSubject = new BehaviorSubject<number>(0);

    public totalPriceSignal = signal(0);
    public totalVatSignal = signal(0);
    public totalDiscountSingal = signal(0);

    get totalVat$(): Observable<number> {
        return this.totalVatSubject.asObservable();
    }
    get totalPrice$(): Observable<number> {
        return this.totalPriceSubject.asObservable();
    }

    calculateTotal(parking: any, additionalServices: any) {
        let totalPrice = 0;
        let totalVat = 0;
        let parkingTotalVat = 0;
        let parkingTotalPrice = 0;
        let additionalServicesTotalPrice = 0;
        let additionServicesTotalVat = 0;

        additionalServices.forEach((service: any) => {
            if (service.value.discountCheckAmount > 0 || service.value.discountCheckPercent > 0) {
                additionalServicesTotalPrice += service.value.discountTotalPrice;
                additionServicesTotalVat += service.value.discountTotalPrice / 1.25 * 0.25;
            } else {
                additionalServicesTotalPrice += service.value.totalPrice;
                additionServicesTotalVat += service.value.vat;
            }
        });

        if (parking.discountCheckPercent > 0 || parking.discountCheckAmount > 0) {
            parkingTotalVat += parking.discountTotalPrice / 1.25 * 0.25;
            parkingTotalPrice += parking.discountTotalPrice;

        } else {
            parkingTotalVat += parking.vat;
            parkingTotalPrice += parking.totalPrice;
        }

        totalPrice = additionalServicesTotalPrice + parkingTotalPrice;
        totalVat = additionServicesTotalVat + parkingTotalVat;

        this.totalPriceSubject.next(totalPrice);
        this.totalVatSubject.next(totalVat);
        this.totalVatSignal.set(totalVat);
        this.totalPriceSignal.set(totalPrice);

    }
}
